<template>
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-if="currentGamePackSlug === ''"
  />
  <img
    class="main_layout_bg sm-hide"
    :src="`/images/games/${currentGameSlug}/buy-wow-gold.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'buy-wow-gold'"
  />
  <img
    class="main_layout_bg sm-hide"
    :src="`/images/games/${currentGameSlug}/wow-pve-boost.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'wow-pve-boost'"
  />
  <img
    class="main_layout_bg sm-hide"
    :src="`/images/games/${currentGameSlug}/wow-pvp-boost.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'wow-pvp-boost'"
  />
  <img
    class="main_layout_bg sm-hide"
    :src="`/images/games/${currentGameSlug}/wow-collections.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'wow-collections.webp'"
  />
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <ElearningPackBanner
      :pack-title="categoryTitle"
      :pack-description="categoryDescription"
      :show-chips="false"
      v-if="
        [
          'wow-pve-boost',
          'wow-pvp-boost',
          'buy-wow-gold',
          'wow-collections',
        ].includes(currentGamePackSlug)
      "
    />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-60 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <CategoriesSelector />
      </div>

      <!-- FOR PACKS -->
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-36"
        v-if="
          ![
            'wow-pve-boost',
            'wow-pvp-boost',
            'buy-wow-gold',
            'wow-collections',
          ].includes(currentGamePackSlug)
        "
        style="overflow-x: hidden"
      ></div>
      <!-- FOR CART -->
      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
        v-if="
          ![
            'wow-pve-boost',
            'wow-pvp-boost',
            'buy-wow-gold',
            'wow-collections',
          ].includes(currentGamePackSlug)
        "
      ></div>
      <!-- FOR GOLD -->
      <div
        class="d-flex-column flex-85 justify-start align-start t-white gap-36 mobile-min-heigh"
        v-else-if="currentGamePackSlug === 'buy-wow-gold'"
      >
        <GoldBoost />
        <!-- <GoldBoostComingSoon /> -->
      </div>
      <!-- CATEGORY -->

      <div
        class="d-flex-column flex-85 justify-start align-start t-white gap-36 mobile-min-heigh"
        v-else-if="
          currentGamePackSlug === 'wow-pvp-boost' ||
          currentGamePackSlug === 'wow-pve-boost' ||
          currentGamePackSlug === 'wow-collections'
        "
      >
        <PvPCategory />
      </div>
    </div>
  </div>
</template>
<script setup>
import ElearningPackBanner from "../banners/ElearningPackBanner.vue";
import CategoriesSelector from "../sections/boosting/CategoriesSelector.vue";
import PvPCategory from "../calculators/wow/PvPCategory.vue";
import GoldBoost from "../calculators/wow/GoldBoost.vue";
import { computed } from "vue";
const { currentGamePackSlug, currentGameSlug } = useGameComposable();

const { getGame } = useGameStore();

const categoryTitle = computed(() => {
  if (
    [
      "wow-pve-boost",
      "wow-pvp-boost",
      "buy-wow-gold",
      "wow-collections",
    ].includes(currentGamePackSlug)
  ) {
    if (getGame?.categories) {
      return getGame.categories?.find((cat) => cat.slug === currentGamePackSlug)
        .title;
    }
    return "";
  }
});
const categoryDescription = computed(() => {
  if (
    [
      "wow-pve-boost",
      "wow-pvp-boost",
      "buy-wow-gold",
      "wow-collections",
    ].includes(currentGamePackSlug)
  ) {
    if (getGame?.categories) {
      return getGame.categories?.find((cat) => cat.slug === currentGamePackSlug)
        .description;
    }
    return "";
  }
});

const category = computed(() => {
  if (
    [
      "wow-pve-boost",
      "wow-pvp-boost",
      "buy-wow-gold",
      "wow-collections",
    ].includes(currentGamePackSlug)
  ) {
    if (getGame?.categories) {
      return getGame.categories?.find(
        (cat) => cat.slug === currentGamePackSlug
      );
    }
    return null;
  }
});

if (
  [
    "wow-pve-boost",
    "wow-pvp-boost",
    "buy-wow-gold",
    "wow-collections",
  ].includes(currentGamePackSlug) &&
  category.value
) {
  // useSeoMeta
  useSeoMeta({
    title: category.value.meta_title,
    description: category.value.description,
  });
}
</script>
